import React, {
  useState,
  useContext,
  useMemo,
  useRef,
  useEffect,
  useCallback,
  Suspense,
  lazy,
  use,
} from "react";
import { ScreenSizeContext } from "../../../context/ScreenSizeProvider";
import { useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom";
import {
  Card,
  Divider,
  CardHeader,
  LinearProgress,
  Box,
  Grid2,
  Typography,
} from "@mui/material";
import { format } from "date-fns";
import { db } from "../../../firebase";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";
import { PDFViewer } from "@react-pdf/renderer";
import Moment from "moment";
import CierreOpsPdf from "./CierreOpsPdf";
import useGlobalConfig from "../../../hooks/globalConfig";
import useGetDataRiderByCompany from "../../../hooks/getDataRiderByCompany";
import * as XLSX from "xlsx";
import ToolDashResumenOps from "../../../components/Dashboard/dashboard/ToolDashResumenOps/ToolDashResumenOps";
import ModalAccionsDispacthDirectionsResolve from "../../../components/ModalAccionsDispacth/ModalAccionsDispacthDirectionsResolve";
import ToolDashAppBar from "../../../components/Dashboard/dashboard/ToolDashAppBar/ToolDashAppBar";
import generarReporteTurnoCierrediario from "../../../utils/Reports/generarReporteTurno";
import FadeInOut from "../../../components/animations/FadeInOut";
import { retiredPodArray } from "../../../utils/objects/retiredPodArray";
import generarReporteExcepciones from "../../../utils/Reports/generarReporteExcepciones";
import generarReporteDiscrepanciasPiking from "../../../utils/Reports/generarReporteDiscrepanciasPiking";
import PopUpAsignament from "../../../components/PopUpAsignament/PopUpAsignament";
import CreateManiFestByCurrentListPdf from "../../../components/CreateManiFestByCurrentListPdf/CreateManiFestByCurrentListPdf";
import { pdf } from "@react-pdf/renderer";
import useGetVehiclesNames from "../../../hooks/getVehiclesNames";
import {
  nonDeliveryCodes,
  translateStatesfalabbela,
  translateStatesfalabbelaCancelations,
} from "../../../utils/objects/translateStates";
import DataGridoOders from "../../../components/DataGridoOders/DataGridoOders";
import * as utils from "../../../utils/objects/BicciExpressOrderStatuses";
import axios from "axios";

var listadeItemsNoMach = [];
var popUpAccion = "-";

const UserListViewOrdersIntFalabella = lazy(() =>
  import(
    "../../../components/UserListViewOrdersIntFalabella/UserListViewOrdersIntFalabella"
  )
);

const GuiasByFalabella = (props) => {
  // console.log(props);
  const location = useLocation();
  const isGuiasFalabellaList = useMemo(
    () => location.pathname.includes("/guiasfalabella/list"),
    [location.pathname]
  );

  const listItems = utils.listItems;

  const { rosettaVehicles, translateStateBicciFalabella, falabellaExcepcions } =
    useGlobalConfig();

  const { widthHeight, movilActive } = useContext(ScreenSizeContext);

  const userUid = useSelector((store) => store.usuario.user.uid);

  const companyId = useMemo(() => {
    if (props.userdata) {
      if (props.userdata.companyCollaborator.includes("falabella")) {
        return `${process.env.REACT_APP_BXTOKETN}`;
      }
      return props.userdata.userCompanyID;
    }
    return "";
  }, [props.userdata]);

  const { VehiclesNames } = useGetVehiclesNames();

  const [falabellaOrders, setFalabellaOrders] = useState([]);

  const [BicciOrders, setBicciOrders] = useState([]);

  const [dataMerge, setDataMerge] = useState([]);

  const [datailInsures, setDetailInsures] = useState([]);

  const [userOrders, setUserOrders] = useState(null);

  const [progressValue, setProgressValue] = useState(0);

  const [wiewAssignmentIndIcon, setWiewAssignment] = useState(true);

  const [itemsDataOrdersForAccions, setItemsDataOrdersForAccions] =
    useState(false);

  const [routesOrdersForAccions, setRoutesOrdersForAccions] = useState([]);

  const [routesOrdersOutAccions, setRoutesOrdersOutAccions] = useState([]);

  const [routesDataOrdersForAccions, setRoutesDataOrdersForAccions] = useState(
    []
  );

  const [routesDataOrdersForAccionsF, setRoutesDataOrdersForAccionsF] =
    useState([]);

  const [cantListItems, setcantListItems] = useState({
    "Procesando..": 0,
    Creadas: 0,
    Ruta: 0,
    Incidencias: 0,
    Finalizadas: 0,
    Total: 0,
  });

  const [menssajeAdmin, setMenssajeAdmin] = useState(null);

  const [initDate, setInitDate] = useState(
    Moment(Date.now()).format("YYYY-MM-DD")
  );

  const [endDate, setEndDate] = useState(
    Moment(Date.now()).format("YYYY-MM-DD")
  );

  const [staticDateBillingFilter, setStaticDateBillingFilter] = useState(
    Moment(Date.now()).format("YYYY-MM-DD")
  );

  const handleClosePopUp = () => {
    setShowPopUp(false);
  };

  const [render, setRender] = useState(true);

  const [realTimeisActive, setRealTimeisActive] = useState(false);

  const [containerHistory, setContainerHistory] = useState({});

  const [metricsOps, setMetricsOps] = useState([]);
  const [metricsOpsRoutes, setMetricsOpsRoutes] = useState([]);

  const [metricsOpsStores, setMetricsOpsStores] = useState([]);

  const [showPopUp, setShowPopUp] = useState(false);
  const [selected, setSelected] = useState(null);
  const [origenGeoCode, setOrigenGeoCode] = useState(null);
  const [adressOrigin, setAdressOrigin] = useState(null);
  const [adressDestiny, setAdressDestiny] = useState(null);
  const [destinyGeoCode, setDestinyGeoCode] = useState(null);
  const [listIdstoSelct, setListIdstoSelct] = useState("");
  const [SelecteDestiny, setSelecteDestiny] = useState(null);
  const [CheckedChangeOE, setCheckedChangeOE] = useState(false);
  const [vertical, setVertical] = useState("");
  const [opemPopUpAsignament, setOpemPopUpAsignament] = useState(false);
  const [ordersHistoryGetProgres, setOrdersHistoryGetProgres] = useState(0);
  const [typeRequets, setTypeRequets] = useState({
    typeRequetsCreate: false,
    typeRequetsUpdate: true,
  });

  const [resetCicle, setResetCicle] = useState({
    currentRequest: 0,
    maxRequest: 10,
    desactiveRealtime: 150,
  });

  const [bicciOrdersExcepData, setBicciOrdersExcepData] = useState([]);

  const [wiewPrePdf, setWiewPrePdf] = useState(false);

  const [Buttondisable, setButtondisable] = useState(true);

  const [typeRquest, setTypeRquest] = useState(false);

  const isMounted = useRef(true);

  const toggleShowRefres = () => setRender(!render);

  const { ridersDataByCompany } = useGetDataRiderByCompany(companyId);

  useEffect(() => {
    setVertical(props.vertical);
  }, [props && props.vertical]);

  useEffect(() => {
    if (companyId && initDate && endDate) {
      ebiexFetchAndMergeOrders(
        initDate,
        endDate,
        typeRequets.typeRequetsCreate ? "createdAt" : "updatedAt",
        props.vertical,
        CheckedChangeOE
      );
    }
  }, [
    companyId,
    initDate,
    endDate,
    CheckedChangeOE,
    props && props.vertical,
    typeRequets,
  ]);

  const dayBoundsLocal = (yyyyMmDd) => {
    const [y, m, d] = yyyyMmDd.split("-").map(Number);
    const start = new Date(y, m - 1, d, 0, 0, 0, 0); // local start-of-day
    const end = new Date(y, m - 1, d + 1, 0, 0, 0, 0); // next day local
    return { start, end }; // Date (local)
  };

  const { start, end } = dayBoundsLocal(initDate);

  async function ebiexFetchAndMergeOrders(
    initDate,
    endDate,
    typeRequest,
    vertical = "all",
    checkedChangeOE = false,
    page = 1,
    limit = 6000
  ) {
    setMenssajeAdmin("Actualizando Órdenes...");
    //REACT_APP_BICCIXPRESS_ONCALL_ORDERS
    const url = process.env.REACT_APP_BICCIXPRESS_ONCALL_ORDERS;
    // Aplicar a otros esenarios
    const bounds = dayBoundsLocal(endDate);
    const body = {
      data: {
        oAutID: process.env.REACT_APP_OAUTID_BICCICL,
        companyID: process.env.REACT_APP_BXTOKETN,
      },
      initDate: start.toISOString(), // desde 00:00 LOCAL de init
      endDate: bounds.end.toISOString(),
      typeRequest, // "createdAt" o "updatedAt"
      vertical, // "all", "HD", "SD", etc.
      page,
      limit,
      checkedChangeOE,
    };

    const config = {
      method: "post",
      maxBodyLength: Infinity,
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.REACT_APP_BICCIXPRESS_API_TOKENT}`,
      },
      data: body,
    };

    try {
      const response = await axios.request(config);

      if (!response.data.data || response.data.data.length === 0) {
        setMenssajeAdmin(
          <span className="alert alert-danger">
            "NO se encuentran envíos para la fecha Solicitada"
          </span>
        );
      } else {
        setMenssajeAdmin(null);
      }

      setDataMerge(response.data.data);
      setResumenTable(response.data.data);
    } catch (error) {
      console.error("Error al obtener órdenes:", error);
      setMenssajeAdmin("error al obtener órdenes");
      //throw error;
    }
  }

  /*
  useEffect(() => {
    if (companyId && initDate && endDate) {
       findOrdesrDispachtFalabella(
         initDate,
         endDate,
         typeRequets,
         companyId,
         props.vertical
       );
       findOrdesrDispachtBicci(
         initDate,
         endDate,
         typeRequets,
         companyId,
         props.vertical
       );
    }
  }, [companyId, initDate, endDate, props && props.vertical]);
  
*/
  useEffect(() => {}, [itemsDataOrdersForAccions]);
  /*
   useEffect(() => {
     if (
       BicciOrders.length > 0 ||
       falabellaOrders.length > 0 ||
       bicciOrdersExcepData.length > 0
     ) {
       setMenssajeAdmin(<span className="alert alert-info">Buscando... </span>);

       BiccidataMerge();
     }
   }, [BicciOrders, falabellaOrders, bicciOrdersExcepData]);
*/
  /*
  useEffect(() => {
    isMounted.current = true;
    setMenssajeAdmin(
      <span className="alert alert-info">Buscando Ordenes... </span>
    );

    findOrdesrDispachtFalabella(
      initDate,
      endDate,
      typeRquest,
      companyId,
      props.vertical
    );
    findOrdesrDispachtBicci(
      initDate,
      endDate,
      typeRequets,
      companyId,
      props.vertical
    );
    return () => {
      isMounted.current = false;
    };
  }, [CheckedChangeOE, typeRequets, props.vertical]);
*/
  useEffect(() => {
    if (dataMerge && ridersDataByCompany) {
      setMenssajeAdmin("Cargando Resumen de Operaciones... ");
      getResumenOps();
      getResumenRoutes();
      getInsuresMetrics();
    }
  }, [dataMerge, ridersDataByCompany]);

  useEffect(() => {
    let interval;
    if (realTimeisActive === true) {
      interval = setInterval(() => {
        resetCicle.currentRequest += 1;
        if (companyId && initDate && endDate) {
          ebiexFetchAndMergeOrders(
            initDate,
            endDate,
            typeRequets.typeRequetsCreate ? "createdAt" : "updatedAt",
            props.vertical,
            CheckedChangeOE
          );
        }
      }, 60000);
    }
    return () => clearInterval(interval);
  }, [realTimeisActive]);

  useEffect(() => {
    if (listIdstoSelct) {
      selecListItames(listIdstoSelct);
    }
  }, [listIdstoSelct]);

  useEffect(() => {}, [render]);

  useEffect(() => {
    // console.log("ordersForAccions", routesOrdersForAccions);
  }, [routesOrdersForAccions]);

  /*
  const findOrdesrDispachtFalabella = async (
    initDate,
    endDate,
    typeRquest,
    companyId
  ) => {
    setMenssajeAdmin(
      <span className="alert alert-info">Buscando... Ordenes Falabella </span>
    );
    const i = new Date(initDate);
    const e = new Date(endDate);

    let temptypeRquestCall;
    if (typeRequets.typeRequetsCreate === true) {
      temptypeRquestCall = "createdAt";
    }
    if (typeRequets.typeRequetsUpdate === true) {
      temptypeRquestCall = "updatedAt";
    }
    setProgressValue(55);

    const allOrdersRef = collection(
      db,
      process.env.REACT_APP_COL_FALABELLA_ORDERS
    );
    function sumarUno(fecha) {
      var res = new Date(fecha);
      res.setDate(res.getDate() + 1);
      return res;
    }
    var endRang = sumarUno(e);

    function restaUno(fecha2) {
      fecha2.setDate(fecha2.getDate());
      return fecha2;
    }

    function sumarDos(fecha) {
      var res = new Date(fecha);
      res.setDate(res.getDate() + 1);
      res.setHours(23);
      res.setMinutes(59);
      res.setSeconds(0);
      res.setMilliseconds(0);
      return res;
    }

    function formatDate(fecha) {
      var res = new Date(fecha);
      res.setHours(23);
      res.setMinutes(59);
      res.setSeconds(0);
      res.setMilliseconds(0);
      return res;
    }

    var rangFinal = sumarDos(e);
    var rangInitial = formatDate(i);
    const dataOrder = {
      data: "",
      get dataEbiex() {
        return this.data;
      },
      set dataEbiex(data) {
        this.data = data;
      },
    };
    dataOrder.data = [];
    if (initDate !== endDate) {
      callNormal();
    }
    if (initDate === endDate) {
      callIgual();
    }

    async function callExceptions() {
      setProgressValue(45);
      try {
        const allOrdersRef = collection(
          db,
          process.env.REACT_APP_COL_FALABELLA_ORDERS
        );

        const q = query(allOrdersRef, where("falabella_status", "!=", "99"));
        const querySnapshot = await getDocs(q);

        const dataOrdesHasExcepciones = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        dataOrdesHasExcepciones.sort((a, b) =>
          a.createdAt.seconds < b.createdAt.seconds ? 1 : -1
        );
        let filtrarSolucionados = dataOrdesHasExcepciones.filter(
          (item) =>
            (item.falabella_status !== "1029") &
            (item.falabella_status !== "1046") &
            (item.falabella_status !== "1023") &
            (item.falabella_status !== "1081") &
            (item.falabella_status !== "1007") &
            (item.falabella_status !== "99")
        );

        let dataOrdesfilterHasExcepciones = filtrarSolucionados.filter(
          (item) => !retiredPodArray.includes("F" + item.id.toString())
        );

        let clearRang = dataOrder.data;
        const arrayId = clearRang.map((obj) => obj.id);

        let clearDataOrdesfilterHasExcepciones =
          dataOrdesfilterHasExcepciones.filter(
            (item) => !arrayId.includes(item.id.toString())
          );

        if (clearDataOrdesfilterHasExcepciones.length > 0) {
          let arryExcepcion = [];
          for (let i = 0; i < clearDataOrdesfilterHasExcepciones.length; i++) {
            arryExcepcion.push("F" + clearDataOrdesfilterHasExcepciones[i].id);
          }

          try {
            const ordersCollectionRef = collection(
              db,
              process.env.REACT_APP_COL_USERS_ORDERS
            );
            const querySnapshot = await getDocs(
              query(ordersCollectionRef, where("id", "in", arryExcepcion))
            );
            const orders = querySnapshot.docs.map((doc) => ({
              id: doc.id,
              ...doc.data(),
            }));

            setBicciOrdersExcepData(orders); // En test
          } catch (error) {}
          if (CheckedChangeOE === false) {
            const resultoFind = dataOrdesfilterHasExcepciones.concat(
              dataOrder.data
            );

            //setResumenTable(resultoFind);
            setFalabellaOrders(resultoFind);
            setMenssajeAdmin(null);

            setMenssajeAdmin(null);
          }

          if (CheckedChangeOE !== false) {
            //setResumenTable(dataOrder.data);
            setFalabellaOrders(dataOrder.data);
            setMenssajeAdmin(null);

            setMenssajeAdmin(null);
          }
        } else {
          //setResumenTable(dataOrder.data);
          setFalabellaOrders(dataOrder.data);
          setProgressValue(100);
          setDataMerge(dataOrder.data); // QA
        }
        //await BiccidataMerge();
      } catch (error) {}

      toggleShowRefres();
    }

    async function callNormal() {
      try {
        const q = query(
          allOrdersRef,
          where(temptypeRquestCall, ">=", rangInitial),
          where(temptypeRquestCall, "<=", endRang)
        );
        const querySnapshot = await getDocs(q);
        var dataOrdes = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        dataOrdes.sort((a, b) =>
          a.updatedAt.seconds < b.updatedAt.seconds ? 1 : -1
        );

        let dataOrdesfilter = dataOrdes.filter(
          (item) => !retiredPodArray.includes("F" + item.id.toString())
        );

        dataOrder.data = dataOrdesfilter;

        callExceptions();
      } catch (error) {
        //console.log(error);
      }
    }

    async function callIgual() {
      try {
        const dataallOrdersfind5 = collection(
          db,
          process.env.REACT_APP_COL_FALABELLA_ORDERS
        );

        const q = query(
          dataallOrdersfind5,
          where(temptypeRquestCall, ">=", rangInitial),
          where(temptypeRquestCall, "<=", rangFinal)
        );
        const querySnapshot5 = await getDocs(q);
        var dataOrdes = querySnapshot5.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        dataOrdes.sort((a, b) =>
          a.updatedAt.seconds < b.updatedAt.seconds ? 1 : -1
        );
        let dataOrdesfilter = dataOrdes.filter(
          (item) => !retiredPodArray.includes("F" + item.id.toString())
        );
        dataOrder.data = dataOrdesfilter;

        callExceptions();
      } catch (error) {
        //console.log(error);
      }
    }
  };

  const findOrdesrDispachtBicci = async (
    initDate,
    endDate,
    typeRequets,
    companyId
  ) => {
    setProgressValue(65);
    setMenssajeAdmin(
      <span className="alert alert-info">Buscando... Ordenes Bicci </span>
    );
    const i = new Date(initDate);
    const e = new Date(endDate);

    let temptypeRquestCall;
    if (typeRequets.typeRequetsCreate === true) {
      temptypeRquestCall = "createdAt";
    }
    if (typeRequets.typeRequetsUpdate === true) {
      temptypeRquestCall = "updatedAt";
    }

    function sumarUno(fecha) {
      var res = new Date(fecha);
      res.setDate(res.getDate() + 1);
      return res;
    }

    var endRang = sumarUno(e);

    function restaUno(fecha2) {
      fecha2.setDate(fecha2.getDate() - 7);
      return fecha2;
    }

    function sumarDos(fecha) {
      var res = new Date(fecha);
      res.setDate(res.getDate() + 1);
      return res;
    }

    var rangInit = restaUno(i);
    var rangFinal = sumarDos(e);

    if (initDate !== endDate) {
      callNormal();
    }
    if (initDate === endDate) {
      callIgual();
    }

    setMenssajeAdmin(
      <span className="alert alert-info">
        Creando resumenes Riders, Vehiculos y Ordenes{" "}
      </span>
    );

    async function callNormal() {
      try {
        const orderRef = collection(db, process.env.REACT_APP_COL_USERS_ORDERS);
        const q = query(
          orderRef,
          where(temptypeRquestCall, ">=", i),
          where(temptypeRquestCall, "<=", endRang)
        );

        const querySnapshot = await getDocs(q);

        const dataOrdesBicci = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        if (bicciOrdersExcepData.length > 0) {
          let mergedate = bicciOrdersExcepData.concat(dataOrdesBicci);
          setBicciOrders(mergedate);
        } else {
          setBicciOrders(dataOrdesBicci);
        }
      } catch (error) {
        //console.log(error);
      }
    }

    async function callIgual() {
      try {
        const orderRef = collection(db, process.env.REACT_APP_COL_USERS_ORDERS);
        const q = query(
          orderRef,
          where(temptypeRquestCall, ">=", rangInit),
          where(temptypeRquestCall, "<=", rangFinal)
        );

        const querySnapshot = await getDocs(q);

        const dataOrdesBicci = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setBicciOrders(dataOrdesBicci);
      } catch (error) {
        //console.log(error);
      }
    }
  };

  const BiccidataMerge = async () => {
    setProgressValue(75);
    setMenssajeAdmin(
      <span className="alert alert-info">Uniendo data... </span>
    );
    var newdataMere = [];
    var DataOrders = BicciOrders;
    var DataOrdersExcep = bicciOrdersExcepData;

    async function initMerge(newdataMere) {
      const uniqueMap = new Map();

      async function removeDuplicatesById(array) {
        for (const item of array) {
          if (!uniqueMap.has(item.id)) {
            uniqueMap.set(item.id, item);
          }
        }

        return Array.from(uniqueMap.values());
      }

      var DataMerge = await removeDuplicatesById(falabellaOrders);

      for (let i = 0; i < DataMerge.length; i++) {
        for (let n = 0; n < newdataMere.length; n++) {
          let socf = "F" + DataMerge[i].id;

          if (socf === newdataMere[n].id) {
            DataMerge[i].isPickedUp = newdataMere[n].isPickedUp
              ? newdataMere[n].isPickedUp
              : false;
            DataMerge[i].placeName = newdataMere[n].placeName;
            DataMerge[i].driverName = newdataMere[n].driverName;
            DataMerge[i].driverAvatar = newdataMere[n].driverAvatar;
            DataMerge[i].driverID = newdataMere[n].driverID;
            DataMerge[i].userNameReceptor = newdataMere[n].userNameReceptor;
            DataMerge[i].userDniReceptor = newdataMere[n].userDniReceptor;
            DataMerge[i].pics = newdataMere[n].pics;
            DataMerge[i].toAddressLocation = newdataMere[n].toAddressLocation;
            DataMerge[i].observationReceptor =
              newdataMere[n].observationReceptor;
            DataMerge[i].observationAdmin = newdataMere[n].observationAdmin;
            DataMerge[i].exceptionGeoRef = newdataMere[n].exceptionGeoRef;
            DataMerge[i].driverLicensePlate = newdataMere[n].driverLicensePlate;
            DataMerge[i].orderNumber = newdataMere[n].orderNumber;
            DataMerge[i].upDatedAtText = format(
              DataMerge[i].updatedAt.seconds * 1000,
              "dd/MM/yy hh:mm:ss"
            ).toString();
            DataMerge[i].dateCreateText = format(
              DataMerge[i].date.seconds * 1000,
              "dd/MM/yy hh:mm:ss"
            ).toString();
          }
        }
      }

      const filteredDataOrdersExcepVertical = DataMerge.filter((item) => {
        if (vertical === "all") {
          return true; // Incluye todos los tipos
        } else if (vertical === "HD") {
          return item.delivery_type === "HD" || item.delivery_type === "HDF";
        } else {
          return item.delivery_type === vertical; // Para "SD" o cualquier otro tipo específico
        }
      });

      setDataMerge(filteredDataOrdersExcepVertical);
      setResumenTable(filteredDataOrdersExcepVertical);

      // setDataMerge(DataMerge);
      // setResumenTable(DataMerge);
    }

    if (DataOrders.length > 0 || DataOrdersExcep.length > 0) {
      const dataOrdersIdSet = new Set(DataOrders.map((item) => item.id));
      const filteredDataOrdersExcep = DataOrdersExcep.filter(
        (item) => !dataOrdersIdSet.has(item.id)
      );

      newdataMere = DataOrders.concat(filteredDataOrdersExcep);
    }

    await initMerge(newdataMere);
  };
*/
  const normalizeIdCore = (id) => {
    const s = String(id || "");
    return s.startsWith("F") ? s.slice(1) : s; // en dataMerge va SIN "F"
  };

  const withFalabellaPrefix = (id) => {
    const s = String(id || "");
    return s.startsWith("F") ? s : `F${s}`; // para API Falabella va CON "F"
  };

  // Extrae el status desde distintas formas de payload
  const extractExceptionCode = (payload) => {
    if (payload == null) return null;
    if (typeof payload === "string" || typeof payload === "number") {
      return String(payload);
    }
    // payload que viene de tu modal: { id, status }
    if (payload.status) return String(payload.status);
    // payload estilo API: { exceptionID }
    if (payload.exceptionID) return String(payload.exceptionID);
    // por si mandan { data: { exceptionID } }
    if (payload.data?.exceptionID) return String(payload.data.exceptionID);
    return null;
  };

  const updateOrderStatusInMerge = useCallback(
    (orderId, payloadOrCode) => {
      const code = extractExceptionCode(payloadOrCode);
      if (!code) return () => {}; // nada que hacer

      const coreId = normalizeIdCore(orderId);
      const nowSeconds = Math.floor(Date.now() / 1000);

      // Snapshot previo para rollback
      let prevRow = null;

      setDataMerge((prev) => {
        let changed = false;

        const next = prev.map((o) => {
          if (String(o.id) !== coreId) return o;

          prevRow = o; // guardamos referencia para rollback
          if (o.falabella_status === code) return o; // sin cambios

          changed = true;
          return {
            ...o,
            falabella_status: code,
            // opcional: feedback visual de "última actualización"
            updatedAt: { seconds: nowSeconds },
            upDatedAtText: format(nowSeconds * 1000, "dd/MM/yy HH:mm:ss"),
          };
        });

        return changed ? next : prev;
      });

      // función de rollback
      const rollback = () => {
        if (!prevRow) return;
        setDataMerge((prev) =>
          prev.map((o) => (String(o.id) === coreId ? prevRow : null))
        );
      };

      return rollback;
    },
    [setDataMerge]
  );

  const getResumenOps = async () => {
    setProgressValue(75);
    setMenssajeAdmin("Creando resumen de operación");

    if (!dataMerge || dataMerge.length === 0) {
      setProgressValue(100);
      setMetricsOps([]);
      setMetricsOpsStores([]);
      setMenssajeAdmin(null);
      return;
    }

    try {
      // rider.id -> vehicleID
      const riderToVehicleIdMap = (ridersDataByCompany || []).reduce(
        (acc, r) => {
          if (r && r.id) acc[r.id] = r.vehicleID ?? null;
          return acc;
        },
        {}
      );

      // vehicle.id -> vehicle.name
      const vehicleIdToNameMap = (VehiclesNames || []).reduce((acc, v) => {
        if (v && v.id) acc[v.id] = v.name ?? "Sin nombre";
        return acc;
      }, {});

      // driverID -> { vehicleId, vehicleName }
      const driverVehicleInfoMap = Object.keys(riderToVehicleIdMap).reduce(
        (acc, driverID) => {
          const vId = riderToVehicleIdMap[driverID];
          acc[driverID] = {
            vehicleId: vId ?? "No registrado",
            vehicleName: vId
              ? vehicleIdToNameMap[vId] ?? "No registrado"
              : "No registrado",
          };
          return acc;
        },
        {}
      );

      setProgressValue(85);

      // ---- Resumen por tienda ----
      // Regla base: entregado si falabella_status === "99"; issues en caso contrario.
      const listStoreOriginMap = (dataMerge || []).reduce((acc, order) => {
        const local = order?.local_provider ?? "Sin tienda";
        if (!acc[local]) {
          acc[local] = { localName: local, delivered: 0, withIssues: 0 };
        }
        if (order?.falabella_status === "99") {
          acc[local].delivered++;
        } else {
          acc[local].withIssues++;
        }
        return acc;
      }, {});

      const listStoreOriging = Object.values(listStoreOriginMap);

      setProgressValue(92);
      /**  antes
      // ---- Resumen por Rider ----
      const ridersMap = (dataMerge || []).reduce((acc, order) => {
        const driverID = order?.driverID ?? "SIN_DRIVER";
        if (!acc[driverID]) {
          const vehicleInfo = driverVehicleInfoMap[driverID] || {
            vehicleId: "No registrado",
            vehicleName: "No registrado",
          };
          acc[driverID] = {
            driverName: order?.driverName ?? "Sin nombre",
            driverID,
            email: order?.email ?? "",
            driverAvatar: order?.driverAvatar ?? "",
            asignados: 0,
            delivery: 0,
            issues: 0,
            vehicleDetailsType: vehicleInfo.vehicleName, // nombre/“tipo”
            vehicleDetailsID: vehicleInfo.vehicleId, // ID real
            locality: {}, // comuna -> count
            countersListOrders: [],
            countersIssuesListOrders: [],
          };
        }

        const bucket = acc[driverID];
        bucket.asignados++;
        if (order?.id) bucket.countersListOrders.push(order.id);

        if (order?.falabella_status === "99") {
          bucket.delivery++;
        } else {
          bucket.issues++;
          if (order?.id) bucket.countersIssuesListOrders.push(order.id);
        }

        const comuna = order?.commune2 ?? "Sin comuna";
        bucket.locality[comuna] = (bucket.locality[comuna] ?? 0) + 1;

        return acc;
      }, {});
*/

      // Normaliza nombres para comparar (sin tildes, minúsculas, trim)
      const norm = (s) =>
        (s || "")
          .toString()
          .trim()
          .toLowerCase()
          .normalize("NFD")
          .replace(/\p{Diacritic}/gu, "");

      // Mapa nombre → driverID real (si lo tienes en ridersDataByCompany)
      const nameToIdMap = (ridersDataByCompany || []).reduce((acc, r) => {
        const name = r?.name || r?.displayName || r?.fullName || r?.alias;
        if (r?.id && name) acc[norm(name)] = r.id;
        return acc;
      }, {});

      // Utilidad para crear bucket vacío
      const makeEmptyBucket = (driverID, driverName, vehicleInfo = null) => ({
        driverName: driverName || "Sin Confirmar",
        driverID: driverID || "",
        email: "",
        driverAvatar: "",
        asignados: 0,
        delivery: 0,
        issues: 0,
        vehicleDetailsType: vehicleInfo?.vehicleName || "No registrado",
        vehicleDetailsID: vehicleInfo?.vehicleId || "No registrado",
        locality: {}, // comuna -> count
        countersListOrders: [],
        countersIssuesListOrders: [],
      });

      // Fusión de buckets (para cuando aparece luego el ID real)
      const mergeBuckets = (target, source) => {
        if (!target.driverName || target.driverName === "Sin Confirmar")
          target.driverName = source.driverName;
        if (!target.email && source.email) target.email = source.email;
        if (!target.driverAvatar && source.driverAvatar)
          target.driverAvatar = source.driverAvatar;

        target.asignados += source.asignados;
        target.delivery += source.delivery;
        target.issues += source.issues;

        Object.entries(source.locality).forEach(([k, v]) => {
          target.locality[k] = (target.locality[k] ?? 0) + v;
        });

        target.countersListOrders.push(...source.countersListOrders);
        target.countersIssuesListOrders.push(
          ...source.countersIssuesListOrders
        );
      };

      // ---- Resumen por Rider con resolución de driverID por nombre ----
      const ridersMap = (dataMerge || []).reduce((acc, order) => {
        const rawId = order?.driverID || ""; // ID recibido
        const rawName = order?.driverName || ""; // Nombre recibido
        const nName = norm(rawName);

        // 1) Resolver ID real por nombre si falta
        let resolvedId = rawId;
        if (!resolvedId && nName) {
          const idFromName = nameToIdMap[nName];
          if (idFromName) {
            resolvedId = idFromName; // ID real encontrado por nombre
          } else {
            resolvedId = `NAME:${nName}`; // Sintético estable por nombre
          }
        }
        if (!resolvedId) resolvedId = "UNASSIGNED"; // último fallback

        // 2) Si aparece ID real y ya existía bucket por NAME:<nName>, fusionar
        const nameKey = nName ? `NAME:${nName}` : null;
        if (rawId && nameKey && acc[nameKey] && !acc[rawId]) {
          // crear bucket destino con info de vehículo si la hay
          const vehicleInfo = driverVehicleInfoMap?.[rawId] || {
            vehicleId: "No registrado",
            vehicleName: "No registrado",
          };
          acc[rawId] = makeEmptyBucket(rawId, rawName, vehicleInfo);
          mergeBuckets(acc[rawId], acc[nameKey]);
          delete acc[nameKey];
        }

        // 3) Asegurar bucket actual
        const key = rawId || resolvedId;
        if (!acc[key]) {
          const vehicleInfo =
            driverVehicleInfoMap?.[rawId] ||
            (rawId
              ? { vehicleId: "No registrado", vehicleName: "No registrado" }
              : null);
          acc[key] = makeEmptyBucket(
            rawId || (key.startsWith("NAME:") ? "" : key),
            rawName,
            vehicleInfo
          );
        }

        // 4) Actualizar datos “mejorando” si llegan más completos
        const bucket = acc[key];
        if (
          rawName &&
          (bucket.driverName === "Sin Confirmar" || !bucket.driverName)
        )
          bucket.driverName = rawName;
        if (rawId && !bucket.driverID) bucket.driverID = rawId;
        if (order?.email && !bucket.email) bucket.email = order.email;
        if (order?.driverAvatar && !bucket.driverAvatar)
          bucket.driverAvatar = order.driverAvatar;

        // 5) Métricas
        bucket.asignados++;
        if (order?.id) bucket.countersListOrders.push(order.id);

        if (order?.falabella_status === "99") {
          bucket.delivery++;
        } else {
          bucket.issues++;
          if (order?.id) bucket.countersIssuesListOrders.push(order.id);
        }

        const comuna = order?.commune2 ?? "Sin comuna";
        bucket.locality[comuna] = (bucket.locality[comuna] ?? 0) + 1;

        return acc;
      }, {});

      // Si necesitas locality como array de {comuna: count}, lo transformamos aquí
      const metricsOps = Object.values(ridersMap).map((r) => ({
        ...r,
        locality: Object.entries(r.locality).map(([k, v]) => ({ [k]: v })),
      }));

      // console.log("metricsOps", metricsOps);
      setMetricsOps(metricsOps);
      setMetricsOpsStores(listStoreOriging);

      setProgressValue(100);
      setMenssajeAdmin(null);
    } catch (error) {
      setProgressValue(100);
      setMenssajeAdmin(
        <span className="alert alert-danger">
          Error al crear el resumen de operación
        </span>
      );
    }
  };

  const getResumenRoutes = async () => {
    if (!dataMerge || dataMerge.length === 0) {
      setMetricsOpsRoutes([]);
      return;
    }

    try {
      const getOrdersByRoute = (data) => {
        return data.reduce((acc, order) => {
          // 1) Detectar si es devolución
          const isReturn = nonDeliveryCodes.has(order.falabella_status);

          // 2) Asignar nombre de ruta: DEVOLUCION o la placa real
          const route = isReturn
            ? "DEVOLUCION"
            : order.driverLicensePlate || "noRoute";

          // 3) El nombre de conductor en DEVOLUCION puede ser fijo o dejarse en blanco
          const driverName = isReturn
            ? "DEVOLUCION"
            : order.driverName || "Sin Asignar";

          const comuna = order.commune2;

          if (!acc[route]) {
            acc[route] = {
              route,
              delivered: 0,
              withIssues: 0,
              assigned: 0,
              pending: 0,
              finalized: 0,
              NS: 0,
              comunas: {},
              drivers: {},
              countersListOrders: [],
              countersIssuresListOrders: [],
            };
          }

          // Contar entregas vs no-entregas (status distinto de 8)
          if (order.status !== 8) {
            acc[route].withIssues++;
          } else {
            acc[route].delivered++;
          }
          acc[route].assigned++;

          // Contar estado falabella (pendientes / finalizados)
          if (order.falabella_status !== "99") {
            acc[route].pending++;
          } else {
            acc[route].finalized++;
          }

          // Comuna
          acc[route].comunas[comuna] = (acc[route].comunas[comuna] || 0) + 1;

          // Conductor
          acc[route].drivers[driverName] =
            (acc[route].drivers[driverName] || 0) + 1;

          // Listas de IDs
          acc[route].countersListOrders.push(order.id);
          // Si no está en estado "99" lo consideramos con incidencia
          if (order.falabella_status !== "99") {
            acc[route].countersIssuresListOrders.push(order.id);
          }

          return acc;
        }, {});
      };

      const listRoutesData = getOrdersByRoute(dataMerge);
      setMetricsOpsRoutes(Object.values(listRoutesData));
    } catch (error) {
      console.error("Error al generar resumen de rutas:", error);
    }
  };

  const getInsuresMetrics = async () => {
    // Crear el objeto detailInsures
    const detailInsuresReq = dataMerge.reduce((acc, order) => {
      const statusKey = String(order.falabella_status);
      // if (!translateStatesfalabbela[statusKey]) {
      //   console.log(
      //     `"estado desconocido :", ${statusKey}, "Folio : ", ${order.id}`
      //   );
      // }
      if (!acc[statusKey]) {
        acc[statusKey] = {
          id: statusKey,
          name: translateStatesfalabbela[statusKey] || "Desconocido",
          cant: 0,
        };
      }
      acc[statusKey].cant++;
      return acc;
    }, {});

    setDetailInsures(Object.values(detailInsuresReq));
  };

  const onChageRange = (e) => {};

  const onChageRangePiker = (createDate, FinalDate) => {
    setInitDate(Moment(new Date(createDate.value)).format("YYYY-MM-DD"));
    setEndDate(Moment(new Date(FinalDate.value)).format("YYYY-MM-DD"));
  };

  const setResumenTable = (dataOrdes) => {
    if (dataOrdes && dataOrdes.length === 0) {
    } else {
      setMenssajeAdmin(null);
    }

    let Creadas = dataOrdes.filter(
      (item) =>
        item.falabella_status === "1058" || item.falabella_status === "1059"
    );

    let Creadaslocal = dataOrdes.filter(
      (item) =>
        item.falabella_status === "" || item.falabella_status === undefined
    );

    //cantListItems.Creadas = Creadas.length
    let Finalizadas = dataOrdes.filter(
      (item) => item.falabella_status === "99"
    );
    //cantListItems.Finalizadas = Finalizadas.length
    let Ruta = dataOrdes.filter(
      (item) =>
        item.falabella_status === "1060" || item.falabella_status === "1061"
    );
    //cantListItems.Ruta = Ruta.length
    let Incidencias = dataOrdes.filter((item) =>
      falabellaExcepcions.includes(item.falabella_status)
    );
    //  cantListItems.Incidencias = Incidencias.length
    //  cantListItems.Total = dataOrdes.length
    setcantListItems({
      "Procesando..": Creadaslocal.length,
      Creadas: Creadas.length,
      Ruta: Ruta.length,
      Incidencias: Incidencias.length,
      Finalizadas: Finalizadas.length,
      Total: dataOrdes.length,
    });
  };

  const isShowPopUp = (accion) => {
    popUpAccion = accion;
    setShowPopUp(!showPopUp);
  };

  async function selecListItames(listIdstoSelct) {
    setRoutesOrdersOutAccions([]);
    listadeItemsNoMach = [];
    let ordersForAccions = [];
    let dataOrdersForAccions = [];
    var tempuserOrders = dataMerge;
    listIdstoSelct = listIdstoSelct.trim();
    var listadeItems2 = listIdstoSelct.split(/[,\s]+/);

    for (let i = 0; i < tempuserOrders.length; i++) {
      tempuserOrders[i].setectedItem = false;
    }
    for (let i = 0; i < listadeItems2.length; i++) {
      for (let n = 0; n < tempuserOrders.length; n++) {
        if (listadeItems2[i] === "F" + tempuserOrders[n].id) {
          tempuserOrders[n].setectedItem = true;
          ordersForAccions.push("F" + tempuserOrders[n].id);
          dataOrdersForAccions.push(tempuserOrders[n]);
        }
      }
    }

    for (let index = 0; index < listadeItems2.length; index++) {
      if (!ordersForAccions.includes(listadeItems2[index])) {
        listadeItemsNoMach.push(listadeItems2[index]);
      }
    }
    setUserOrders(tempuserOrders);
    setDataMerge(tempuserOrders);
    setRender(!render);
    if (ordersForAccions.length > 0) {
      setItemsDataOrdersForAccions(true);
      setRoutesDataOrdersForAccions(dataOrdersForAccions);
      setRoutesOrdersForAccions(ordersForAccions);
    } else {
      setItemsDataOrdersForAccions(false);
    }
  }

  const UpdateOrderForAcctions = (items) => {
    listadeItemsNoMach = [];
    let ordersForAccions = [];
    let dataOrdersForAccions = [];
    var tempuserOrders = dataMerge;
    var listadeItems = items;

    for (let i = 0; i < tempuserOrders.length; i++) {
      tempuserOrders[i].setectedItem = false;
    }
    for (let i = 0; i < listadeItems.length; i++) {
      for (let n = 0; n < tempuserOrders.length; n++) {
        if (listadeItems[i] === "F" + tempuserOrders[n].id) {
          tempuserOrders[n].setectedItem = true;
          ordersForAccions.push("F" + tempuserOrders[n].id);
          dataOrdersForAccions.push(tempuserOrders[n]);
        }
      }
    }

    for (let index = 0; index < listadeItems.length; index++) {
      if (!ordersForAccions.includes("F" + listadeItems[index])) {
        listadeItemsNoMach.push(listadeItems[index]);
      }
    }

    if (ordersForAccions.length > 0) {
      setItemsDataOrdersForAccions(true);
      setRoutesDataOrdersForAccions(dataOrdersForAccions);
      setRoutesOrdersForAccions(ordersForAccions);
    } else {
      setItemsDataOrdersForAccions(false);
    }
    setUserOrders(tempuserOrders);
    setDataMerge(tempuserOrders);
    setRender(!render);
  };

  // Optimizado
  const handleClickSelectRiderCurrentList = useCallback(
    (e, item) => {
      e.preventDefault();
      setRoutesOrdersOutAccions([]);

      const normalizeID = (id) => (String(id).startsWith("F") ? id : "F" + id);

      let listadeItemsNoMach = [];
      let ordersForAccions = new Set();
      let dataOrdersForAccions = [];
      let dataOrdersForAccionsF = [];
      let tempuserOrders = [...dataMerge];
      let listadeItems = new Set(item.countersListOrders);

      const tempuserOrdersMap = new Map();
      tempuserOrders.forEach((order) => {
        order.setectedItem = false;
        tempuserOrdersMap.set(order.id, order);
        tempuserOrdersMap.set(normalizeID(order.id), order); // permite buscar con "F" o sin "F"
      });

      listadeItems.forEach((id) => {
        const order = tempuserOrdersMap.get(id);
        if (order) {
          order.setectedItem = true;
          ordersForAccions.add(normalizeID(id));
          dataOrdersForAccions.push(order);
        }
      });

      listadeItems.forEach((id) => {
        const order = tempuserOrdersMap.get(id);
        if (order) {
          order.setectedItem = true;
          dataOrdersForAccionsF.push(order);
        }
      });

      listadeItems.forEach((id) => {
        const normalized = normalizeID(id);
        if (!ordersForAccions.has(normalized)) {
          listadeItemsNoMach.push(normalized);
        }
      });

      setUserOrders(tempuserOrders);
      setDataMerge(tempuserOrders);

      if (ordersForAccions.size > 0) {
        setItemsDataOrdersForAccions(true);
        setRoutesDataOrdersForAccions(dataOrdersForAccions);
        setRoutesDataOrdersForAccionsF(dataOrdersForAccionsF);
        setRoutesOrdersForAccions(Array.from(ordersForAccions));
      } else {
        setItemsDataOrdersForAccions(false);
      }

      setRender((prevRender) => !prevRender);
    },
    [dataMerge]
  );

  // Optimizado
  const handleClickSelectRiderPendintList = useCallback(
    (e, item) => {
      e.preventDefault();

      let listadeItemsNoMach = [];
      const ordersForAccions = new Set();
      const dataOrdersForAccions = [];
      const dataOrdersForAccionsF = [];

      // Clonamos el array y normalizamos IDs
      const tempuserOrders = dataMerge.map((order) => {
        order.setectedItem = false;
        return order;
      });

      // Construimos un Map para buscar por "1234" y por "F1234"
      const tempuserOrdersMap = new Map();
      tempuserOrders.forEach((order) => {
        tempuserOrdersMap.set(order.id, order);
        tempuserOrdersMap.set("F" + order.id, order);
      });

      // Conjunto de IDs entrantes (pueden venir sin "F")
      const listadeItems = new Set(item.countersListOrders);

      // Seleccionamos las órdenes cuyo estado sea 1060 o 1061
      listadeItems.forEach((idRaw) => {
        const key = String(idRaw).startsWith("F") ? idRaw : "F" + idRaw;
        const order = tempuserOrdersMap.get(key);
        if (
          order &&
          (order.falabella_status === "1060" ||
            order.falabella_status === "1061")
        ) {
          order.setectedItem = true;
          ordersForAccions.add(key);
          dataOrdersForAccions.push(order);
        }
      });

      // Creamos la lista F completa (para el detalle visual)
      listadeItems.forEach((idRaw) => {
        const key = String(idRaw).startsWith("F") ? idRaw : "F" + idRaw;
        const order = tempuserOrdersMap.get(key);
        if (order) {
          order.setectedItem = true;
          dataOrdersForAccionsF.push(order);
        }
      });

      // Aquellas IDs que no entraron en ordersForAccions (y no estén entregadas "99")
      listadeItems.forEach((idRaw) => {
        const key = String(idRaw).startsWith("F") ? idRaw : "F" + idRaw;
        if (!ordersForAccions.has(key)) {
          const order = tempuserOrdersMap.get(key);
          if (order && order.falabella_status !== "99") {
            listadeItemsNoMach.push(key);
          }
        }
      });

      // Actualizamos estado
      setUserOrders(tempuserOrders);
      setDataMerge(tempuserOrders);

      const hasSelection = ordersForAccions.size > 0;
      setItemsDataOrdersForAccions(hasSelection);
      setRoutesDataOrdersForAccions(dataOrdersForAccions);
      setRoutesDataOrdersForAccionsF(dataOrdersForAccionsF);
      setRoutesOrdersForAccions(Array.from(ordersForAccions));
      setRoutesOrdersOutAccions(listadeItemsNoMach);

      // Fuerza re-render
      setRender((prev) => !prev);
    },
    [dataMerge]
  );

  const handleClickSelectNewList = (e, item) => {
    e.preventDefault();

    const normalizeID = (id) => (String(id).startsWith("F") ? id : "F" + id);

    const ordersForAccions = new Set();
    const dataOrdersForAccions = [];
    const dataOrdersForAccionsF = [];
    const listadeItemsNoMach = [];

    const listadeItems = new Set(item.countersListOrders);
    const tempuserOrders = [...dataMerge];
    const tempuserOrdersMap = new Map();

    // 1) Construir mapa
    tempuserOrders.forEach((order) => {
      order.setectedItem = false;
      tempuserOrdersMap.set(order.id, order);
      tempuserOrdersMap.set(normalizeID(order.id), order);
    });

    // 2) Recorrer IDs seleccionados
    listadeItems.forEach((rawId) => {
      const id = normalizeID(rawId);
      const order = tempuserOrdersMap.get(id);
      if (!order) return;

      order.setectedItem = true;
      dataOrdersForAccionsF.push(order);

      if (!order.driverID || !String(order.driverID).trim()) {
        ordersForAccions.add(id);
        dataOrdersForAccions.push(order);
      } else {
        listadeItemsNoMach.push(id);
      }
    });

    // ————— FILTRO FINAL —————
    // 1) Quitar de dataOrdersForAccions los non-delivery
    const filteredData = dataOrdersForAccions.filter(
      (order) => !nonDeliveryCodes.has(String(order.falabella_status))
    );
    // 2) Reconstruir dataOrdersForAccions in-place
    dataOrdersForAccions.length = 0;
    dataOrdersForAccions.push(...filteredData);
    // 3) Reconstruir ordersForAccions a partir de los IDs válidos
    ordersForAccions.clear();
    filteredData.forEach((order) => {
      ordersForAccions.add(normalizeID(order.id));
    });
    // ————————————————————

    // console.log(
    //   "Filtered Data Orders For Accions:",
    //   dataOrdersForAccions.length
    // );
    // console.log("Orders For Accions:", Array.from(ordersForAccions).length);
    // console.log("Listade Items No Mach:", listadeItemsNoMach.length);
    // console.log("Temp User Orders:", tempuserOrders.length);

    // 3) Actualizar estados y hooks
    setUserOrders(tempuserOrders);
    setDataMerge(tempuserOrders);

    const hasSelected = ordersForAccions.size > 0;
    setItemsDataOrdersForAccions(hasSelected);
    setRoutesDataOrdersForAccions(dataOrdersForAccions);
    setRoutesDataOrdersForAccionsF(dataOrdersForAccionsF);
    setRoutesOrdersForAccions(Array.from(ordersForAccions));
    setRoutesOrdersOutAccions(listadeItemsNoMach);

    setRender((prev) => !prev);
  };
  // Optimizado
  const handleCopySelectRiderCurrentList = (e, item) => {
    e.preventDefault();

    listadeItemsNoMach = [];
    let copyOrdersForAccions = [];
    var tempuserOrders = dataMerge.slice();
    var listadeItems = new Set(item.countersListOrders);

    try {
      const tempuserOrdersMap = new Map();
      tempuserOrders.forEach((order) => {
        tempuserOrdersMap.set(order.id, order);
      });

      listadeItems.forEach((id) => {
        const order = tempuserOrdersMap.get(id);
        if (order) {
          copyOrdersForAccions.push("F" + order.id);
        }
      });

      let copyData = copyOrdersForAccions.join("\n"); // Convertir a string con saltos de línea
      navigator.clipboard.writeText(copyData);
      setRender(!render);
    } catch (error) {
      console.log(error);
    }
  };

  const createManiFestByCurrentList = async (e, item) => {
    e.preventDefault();

    listadeItemsNoMach = [];
    let copyOrdersForAccions = [];
    var tempuserOrders = dataMerge;
    var listadeItems = item.countersListOrders;

    for (let i = 0; i < listadeItems.length; i++) {
      for (let n = 0; n < tempuserOrders.length; n++) {
        if (listadeItems[i] === tempuserOrders[n].id) {
          copyOrdersForAccions.push(tempuserOrders[n]);
        }
      }
    }

    const blob = await pdf(
      <CreateManiFestByCurrentListPdf orders={copyOrdersForAccions} />
    ).toBlob();

    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  const handleCopySelectRiderCurrentListErrors = (e, item) => {
    e.preventDefault();
    navigator.clipboard.writeText(item);
  };

  const handleChangeOE = () => {
    setCheckedChangeOE(!CheckedChangeOE);
  };

  const handleChangetypeRequets = (e) => {
    const { name, checked } = e.currentTarget;
    if (name === "typeRequetsCreate" && checked) {
      setTypeRequets({ typeRequetsCreate: true, typeRequetsUpdate: false });
    } else {
      setTypeRequets({ typeRequetsCreate: false, typeRequetsUpdate: true });
    }
  };

  const generarReporteTurno = (data) => {
    generarReporteTurnoCierrediario(data, ridersDataByCompany, initDate);
  };

  const generarReporteDiscrepancias = (data) => {
    generarReporteDiscrepanciasPiking(data);
  };

  const generarReporteExcepcionesPendientes = (data) => {
    generarReporteExcepciones(data, ridersDataByCompany, initDate);
  };

  const generarReporteEstados = (dataOrdersForAccions) => {
    const matrizReporte = [
      [
        "Suborden",
        "Creado",
        "Estatus",
        "Descripción",
        "Última Actualización",
        "Resumen de entrega",
      ],
      ...dataOrdersForAccions.map((dato) => [
        dato.soc,
        dato.dateCreateText,
        dato.falabella_status,
        translateStateBicciFalabella[dato.falabella_status],
        dato.upDatedAtText,
        `${dato.upDatedAtText},  ${dato.userNameReceptor}, ${dato.userDniReceptor}`,
      ]),
    ];
    const libro = XLSX.utils.book_new();
    const hoja = XLSX.utils.aoa_to_sheet(matrizReporte);
    XLSX.utils.book_append_sheet(libro, hoja, "DATA");

    XLSX.writeFile(
      libro,
      `ESTADOS ${Moment(Date.now()).format("YYYY-MM-DD")}.xlsx`
    );
  };

  const generarReporteEvidencias = (dataOrdersForAccions) => {
    const matrizReporte = [
      [
        "SOC",
        "Fecha de envío",
        "Zonas",
        "Ultimo Registro",
        "Estatus",
        "Detalle",
        "Conductor",
        "Fotos",
        "Fotos",
        "Fotos",
        "Fotos",
      ],
      ...dataOrdersForAccions.map((dato) => [
        dato.soc,
        dato.dateCreateText,
        dato.commune2,
        format(dato.updatedAt.seconds * 1000, "dd/MM/yy hh:mm:ss"),
        dato.falabella_status,
        translateStateBicciFalabella[dato.falabella_status],
        dato.driverName,
        dato.pics[0],
        dato.pics[1],
        dato.pics[2],
        dato.pics[3],
        dato.pics[4],
        dato.pics[5],
      ]),
    ];
    const libro = XLSX.utils.book_new();
    const hoja = XLSX.utils.aoa_to_sheet(matrizReporte);
    XLSX.utils.book_append_sheet(libro, hoja, "DATA");

    XLSX.writeFile(
      libro,
      `Evidencias entregas ${Moment(Date.now()).format("YYYY-MM-DD")}.xlsx`
    );
  };

  const findHistorials = async () => {
    let cantGet = falabellaOrders.length;

    let dataDocsContainer = {};

    for (let i = 0; i < cantGet; i++) {
      let porcentajeDeAvance = (i / cantGet) * 100;
      setOrdersHistoryGetProgres(porcentajeDeAvance);

      try {
        const clearID = falabellaOrders[i].id; //.replace(/F/g, "");
        const falabellaOrderRef = collection(
          db,
          process.env.REACT_APP_COL_FALABELLA_ORDERS
        );

        const statusRef = doc(falabellaOrderRef, clearID.toString());

        const statusDocs = collection(statusRef, "status");

        const dataallOrdersfind5 = await getDocs(statusDocs);
        const datadocuments = dataallOrdersfind5.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        datadocuments.sort((a, b) =>
          a.createdAt.seconds < b.createdAt.seconds ? 1 : -1
        );

        dataDocsContainer[falabellaOrders[i].id] = datadocuments;
      } catch (error) {}
    }
    setOrdersHistoryGetProgres(100);
    setContainerHistory(dataDocsContainer);
  };

  const handlePrintCierreOps = async () => {
    if (!metricsOps || !metricsOpsStores) return;

    // Generar el PDF como blob
    const blob = await pdf(
      <CierreOpsPdf
        items={listItems}
        cant={cantListItems}
        metricsOps={metricsOps}
        metricsOpsStores={metricsOpsStores}
        rosettaVehicles={rosettaVehicles}
        userUid={userUid}
        initDate={initDate}
        endDate={endDate}
        typeReport={props.vertical}
      />
    ).toBlob();

    // Crear una URL del blob y abrir en nueva pestaña
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  return (
    <Grid2 celled="internally" id="expresscuentaContent">
      <Grid2>
        <Grid2
          computer={16}
          mobile={16}
          tablet={16}
          className="dash-container-colmun"
        >
          <Card className="typeMiniforms">
            {movilActive === true ? (
              <>
                <CardHeader
                  title="Ordenes Falabella"
                  subheader={
                    <ToolDashAppBar
                      movil={widthHeight.width < 950 ? true : false}
                      datailInsures={datailInsures}
                      setSelected={setSelected}
                      setOrigenGeoCode={setOrigenGeoCode}
                      setAdressOrigin={setAdressOrigin}
                      adressOrigin={adressOrigin}
                      setSelecteDestiny={setSelecteDestiny}
                      setDestinyGeoCode={setDestinyGeoCode}
                      setAdressDestiny={setAdressDestiny}
                      adressDestiny={adressDestiny}
                      Buttondisable={Buttondisable}
                      isShowPopUp={isShowPopUp}
                      setButtondisable={setButtondisable}
                      CheckedChangeOE={CheckedChangeOE}
                      handleChangeOE={handleChangeOE}
                      handleChangetypeRequets={handleChangetypeRequets}
                      typeRequets={typeRequets}
                      dataMerge={dataMerge}
                      dataOrdersForAccions={routesDataOrdersForAccions}
                      generarReporteEstados={generarReporteEstados}
                      generarReporteEvidencias={generarReporteEvidencias}
                      setWiewPrePdf={setWiewPrePdf}
                      findHistorials={findHistorials}
                      wiewPrePdf={wiewPrePdf}
                      initDate={initDate}
                      endDate={endDate}
                      onChageRangePiker={onChageRangePiker}
                      onChageRange={onChageRange}
                      staticDateBillingFilter={staticDateBillingFilter}
                      setListIdstoSelct={setListIdstoSelct}
                      listadeItemsNoMach={listadeItemsNoMach}
                      companyId={companyId}
                      realTimeisActive={realTimeisActive}
                      setRealTimeisActive={setRealTimeisActive}
                      listItems={listItems}
                      cantListItems={cantListItems}
                      handleCopySelectRiderCurrentListErrors={
                        handleCopySelectRiderCurrentListErrors
                      }
                      setWiewAssignment={setWiewAssignment}
                      wiewAssignmentIndIcon={wiewAssignmentIndIcon}
                      setOpemPopUpAsignament={setOpemPopUpAsignament}
                      handlePrintCierreOps={handlePrintCierreOps}
                      metricsOps={metricsOps}
                      routesOrdersOutAccions={routesOrdersOutAccions}
                    ></ToolDashAppBar>
                  }
                  sx={{
                    padding: "16px",
                    flexDirection: "column",
                    alignItems: "stretch",
                    justifyContent: "flex-start",
                    "& .Routes-wrapper": {
                      flexDirection: "column",
                      alignItems: "center",
                    },
                    "& .realtime-label": {
                      marginTop: "0.5rem",
                    },
                    "& .realtime-info": {
                      marginTop: "0.5rem",
                    },
                    "& .realtime-pause": {
                      marginTop: "0.5rem",
                      textAlign: "center",
                    },
                    "& .searcher-wrapper": {
                      marginTop: "0.5rem",
                    },
                    "@media (min-width: 950px)": {
                      padding: "16px 24px",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "space-between",
                      "& .Routes-wrapper": {
                        flexDirection: "row",
                        alignItems: "center",
                      },
                      "& .realtime-label": {
                        marginTop: 0,
                        marginRight: "1rem",
                      },
                      "& .realtime-pause": {
                        marginTop: 0,
                      },
                      "& .searcher-wrapper": {
                        marginTop: 0,
                      },
                    },
                  }}
                />
              </>
            ) : (
              <>
                {" "}
                <CardHeader
                  title=""
                  subheader={
                    <div>
                      <ToolDashAppBar
                        movil={widthHeight.width < 950 ? true : false}
                        setSelected={setSelected}
                        setOrigenGeoCode={setOrigenGeoCode}
                        setAdressOrigin={setAdressOrigin}
                        adressOrigin={adressOrigin}
                        setSelecteDestiny={setSelecteDestiny}
                        setDestinyGeoCode={setDestinyGeoCode}
                        setAdressDestiny={setAdressDestiny}
                        adressDestiny={adressDestiny}
                        Buttondisable={Buttondisable}
                        isShowPopUp={isShowPopUp}
                        setButtondisable={setButtondisable}
                        CheckedChangeOE={CheckedChangeOE}
                        handleChangeOE={handleChangeOE}
                        handleChangetypeRequets={handleChangetypeRequets}
                        typeRequets={typeRequets}
                        dataMerge={dataMerge}
                        dataOrdersForAccions={routesDataOrdersForAccions}
                        generarReporteEstados={generarReporteEstados}
                        generarReporteEvidencias={generarReporteEvidencias}
                        generarReporteTurno={generarReporteTurno}
                        generarReporteDiscrepancias={
                          generarReporteDiscrepancias
                        }
                        generarReporteExcepcionesPendientes={
                          generarReporteExcepcionesPendientes
                        }
                        setWiewPrePdf={setWiewPrePdf}
                        findHistorials={findHistorials}
                        wiewPrePdf={wiewPrePdf}
                        initDate={initDate}
                        endDate={endDate}
                        onChageRangePiker={onChageRangePiker}
                        onChageRange={onChageRange}
                        staticDateBillingFilter={staticDateBillingFilter}
                        setListIdstoSelct={setListIdstoSelct}
                        listadeItemsNoMach={listadeItemsNoMach}
                        companyId={companyId}
                        realTimeisActive={realTimeisActive}
                        setRealTimeisActive={setRealTimeisActive}
                        listItems={listItems}
                        cantListItems={cantListItems}
                        datailInsures={datailInsures}
                        handleCopySelectRiderCurrentListErrors={
                          handleCopySelectRiderCurrentListErrors
                        }
                        setWiewAssignment={setWiewAssignment}
                        wiewAssignmentIndIcon={wiewAssignmentIndIcon}
                        setOpemPopUpAsignament={setOpemPopUpAsignament}
                        handlePrintCierreOps={handlePrintCierreOps}
                        metricsOps={metricsOps}
                        routesOrdersOutAccions={routesOrdersOutAccions}
                      ></ToolDashAppBar>

                      <CardHeader subheader={""} />
                      <div className="Routes-container"></div>
                    </div>
                  }
                  sx={{ padding: "0px" }}
                />
              </>
            )}

            <Divider />

            <Box className="formcontent">
              <div className="m-2">
                {menssajeAdmin ? (
                  <Box
                    sx={{
                      padding: "20px",
                      position: "absolute",
                      background: "#00AAFF",
                      borderRadius: "5px",
                      color: "#F8F8F8",
                      right: "5px",
                      zIndex: 1000,
                    }}
                  >
                    {" "}
                    {menssajeAdmin}
                  </Box>
                ) : (
                  <>
                    {progressValue !== 100 ? (
                      <LinearProgress
                        sx={{ position: "fixed" }}
                      ></LinearProgress>
                    ) : null}
                  </>
                )}
              </div>
              <div className="frontMetricBar">
                <div className="content-small-screm">
                  <FadeInOut
                    sx={{ padding: "0px" }}
                    show={wiewAssignmentIndIcon}
                    duration={500}
                  >
                    <ToolDashResumenOps
                      movil={widthHeight.width < 1234 ? true : false}
                      metricsOps={metricsOps}
                      handleClickSelectRiderCurrentList={
                        handleClickSelectRiderCurrentList
                      }
                      handleClickSelectRiderPendintList={
                        handleClickSelectRiderPendintList
                      }
                      handleCopySelectRiderCurrentList={
                        handleCopySelectRiderCurrentList
                      }
                      handleClickSelectNewList={handleClickSelectNewList}
                      rosettaVehicles={rosettaVehicles}
                      createManiFestByCurrentList={createManiFestByCurrentList}
                      metricsOpsRoutes={metricsOpsRoutes}
                    ></ToolDashResumenOps>
                  </FadeInOut>
                </div>
              </div>{" "}
              <div></div>
              <Grid2>
                <Grid2 className="dash-container-colmun ">
                  {/* <div>
                    
                    {wiewPrePdf && metricsOps && metricsOpsStores ? (
                      <PDFViewer style={{ width: "100%", height: "90vh" }}>
                        <CierreOpsPdf
                          items={listItems}
                          cant={cantListItems}
                          metricsOps={metricsOps}
                          metricsOpsStores={metricsOpsStores}
                          rosettaVehicles={rosettaVehicles}
                          userUid={userUid}
                          initDate={initDate}
                          endDate={endDate}
                          typeReport={props.vertical}
                        ></CierreOpsPdf>
                      </PDFViewer>
                    ) : null}
                  </div> */}
                  <div>
                    {isGuiasFalabellaList ? (
                      <UserListViewOrdersIntFalabella
                        movil={widthHeight.width < 1234 ? true : false}
                        dataOrdesRequets={dataMerge}
                        visibleBilling={false}
                        ordersForAccions={routesOrdersForAccions}
                        UpdateOrderForAcctions={UpdateOrderForAcctions}
                        companyId={companyId}
                      />
                    ) : (
                      <div>
                        {dataMerge.length < 50 ? (
                          <Suspense fallback={<div>Loading...</div>}>
                            <UserListViewOrdersIntFalabella
                              movil={widthHeight.width < 1234 ? true : false}
                              dataOrdesRequets={dataMerge}
                              visibleBilling={false}
                              ordersForAccions={routesOrdersForAccions}
                              UpdateOrderForAcctions={UpdateOrderForAcctions}
                              companyId={companyId}
                              firebaseUser={props.firebaseUser}
                              updateOrderStatusInMerge={
                                updateOrderStatusInMerge
                              }
                            />
                          </Suspense>
                        ) : (
                          <Box>
                            <Box
                              sx={{
                                backgroundColor: "#ff7f00",
                                color: "#F8F8F8",
                                padding: "20px",
                              }}
                            >
                              {" "}
                              <NavLink
                                to={{
                                  pathname: `/dashboard/guiasfalabella/list`,
                                }}
                                color="primary"
                                variant="contained"
                              >
                                {" "}
                                <Typography sx={{ color: "#F8F8F8" }}>
                                  {" "}
                                  Alto volumen en la consulta. Modo Solo de
                                  ruteo activado, si deseas ver el listado de
                                  órdenes con más detalles, Has clic aquí. Ver
                                  Listado de Órdenes
                                </Typography>{" "}
                              </NavLink>
                            </Box>
                            <Box>
                              <DataGridoOders
                                dataOrdesRequets={dataMerge}
                                UpdateOrderForAcctions={UpdateOrderForAcctions}
                                updateOrderStatusInMerge={
                                  updateOrderStatusInMerge
                                }
                                firebaseUser={props.firebaseUser}
                              ></DataGridoOders>
                            </Box>
                          </Box>
                        )}
                      </div>
                    )}
                  </div>
                </Grid2>

                <Grid2
                  computer={6}
                  mobile={16}
                  tablet={16}
                  className="dash-container-colmun"
                >
                  {/* <LatestProducts  />  */}
                </Grid2>
              </Grid2>
            </Box>

            <Divider />
          </Card>
          <div></div>
          {showPopUp ? (
            <ModalAccionsDispacthDirectionsResolve
              opened={showPopUp}
              handleClosePopUp={handleClosePopUp}
              popUpAccion={popUpAccion}
              interfaceOrigen={"liveOrders"}
              ordersForAccions={routesOrdersForAccions}
              dataOrdersForAccions={routesDataOrdersForAccions}
              companyId={companyId}
              ridersDataByCompany={ridersDataByCompany}
              adressOrigin={adressOrigin}
              origenGeoCode={origenGeoCode}
              adressDestiny={adressDestiny}
              destinyGeoCode={destinyGeoCode}
            >
              {" "}
            </ModalAccionsDispacthDirectionsResolve>
          ) : null}
          {ridersDataByCompany ? (
            <PopUpAsignament
              opemPopUpAsignament={opemPopUpAsignament}
              setOpemPopUpAsignament={setOpemPopUpAsignament}
              ordersForAccions={routesOrdersForAccions}
              ridersDataByCompany={ridersDataByCompany}
              routesDataOrdersForAccions={routesDataOrdersForAccionsF}
            ></PopUpAsignament>
          ) : null}
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default GuiasByFalabella;
